module.exports = __webpack_public_path__ + "static/media/education-spot-clear.336ab370.svg";